import React from 'react'

export default function BlogTemplate({data}) {
  
    
       return(
        <div class=" font-Poppins w-full px-5 py-24 mx-auto lg:px-32">
        <div class="flex flex-col lg:flex-row lg:space-x-12">
            <div class="order-last w-full max-w-screen-sm m-auto mt-12 lg:w-1/4 lg:order-first">
                <div class="p-4 transition duration-500 ease-in-out transform bg-white border rounded-lg">
                    <div class="flex py-2 mb-4">
                        <div class="ml-4">
                            <p class="text-sm font-medium text-gray-900">Sammer Ijaz</p>
                            <p class="text-sm text-gray-500">Writer</p>
                        </div>
                    </div>
                    <div>
                        <a href= {`https://twitter.com/SameerIjazMalik?t=Jdn4RrnS5kEmm4DR_jTDKQ&s=08 `}class="flex items-center px-6 py-2 mt-auto text-lg text-white transition duration-500 ease-in-out transform bg-blue-600 border border-current rounded hover:bg-blue-700 focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-2">Follow us on Twitter</a>
                    </div>
                </div>
            </div>
            <div class="w-full px-4 mt-12 prose lg:px-0 lg:w-3/4">
                <div class="mb-5 border-b border-gray-200">
                    <div class="flex flex-wrap items-baseline -mt-2">
                        <h5 className='mb-3'>{data.date}</h5>                    </div>
                </div>
                <img class="h-100 rounded w-full object-cover object-center mb-6" src={`${data.image}`} alt="content"/>
                <h1 className='sm:text-5xl text-4xl font-PoppinsBold mb-4'>{data.title}</h1>
                {
                    data.paragrph.map((data)=>{
                        if(data.heading){
                            return(<div>
                                <h1 className='sm:text-3xl text-2xl font-Poppins mb-4'>{data.heading}</h1>
                            <p className='font-PoppinsLight text-lg mb-4'>{data.para}</p></div>)
                        }
                        else{
                            return( <p className='font-PoppinsLight text-lg mb-4'>{data.para}</p>)
                        }
                        
                    })
                }
                
                </div>
        </div>
    </div>
       )
     
    
 
  
}

